<app-profile-layout>
  <!-- <app-shared-breadcrumb
    [addMarketplace]="true"
    [items]="[{ label: 'Upload Buyers List' }]"
  ></app-shared-breadcrumb> -->

  <div class="mb-6">
    <app-shared-page-title
      name="Upload Buyers List (Private - Not Shared)"
      helpModal="upload-buyers"
    ></app-shared-page-title>
  </div>

  <ng-container *ngIf="loadingAllowed">
    <app-shared-loading
      position="left"
      text="Loading organization..."
    ></app-shared-loading>
  </ng-container>

  <ng-container *ngIf="!loadingAllowed">
    <ng-container *ngIf="allowedAPIError">
      <div>
        ⚠️ To upload a buyers list, you must first set up your organization.
        <a routerLink="/my-organization" class="text-primary-500">Click here</a>
        to complete your organization setup.
      </div>
    </ng-container>

    <ng-container *ngIf="!allowedAPIError">
      <div class="-mt-4 mb-5">
        Please upload your buyers list as a CSV file. Ensure the file contains
        no more than {{ maxRows }} rows.
        <a routerLink="/manage-buyers-lists" class="text-primary-500"
          >Click here</a
        >
        to manage your buyers lists.
      </div>

      <div *ngIf="!isAllowed" class="mb-4">
        ⚠️ <span class="font-medium">Free tier:</span> You already created
        {{ numberOfLists }} buyers lists. Please upgrade to a paid tier to
        create more buyers lists.
      </div>

      <ng-container *ngIf="isAllowed">
        <div class="-mt-4 mb-4" *ngIf="numberOfLists >= 1">
          ⚠️ <span class="font-medium">Free tier:</span> {{ numberOfLists }} of
          20 buyers lists created.
        </div>

        <app-upload-buyers-file
          [uploading]="uploading"
          [uploaded]="uploaded"
          [file]="file"
          (fileSelected)="handleFileSelected($event)"
          (clearFileSelected)="clearSelectedFile()"
        ></app-upload-buyers-file>

        <ng-container *ngIf="file">
          <app-upload-buyers-name
            [uploading]="uploading"
            [uploaded]="uploaded"
            (nameChange)="onNameChange($event)"
          ></app-upload-buyers-name>

          <app-upload-buyers-has-header
            [uploading]="uploading"
            [uploaded]="uploaded"
            (hasHeaderChange)="onHasHeaderChange($event)"
          ></app-upload-buyers-has-header>

          <ng-container *ngIf="!!hasHeader">
            <app-upload-buyers-file-map
              [columnMapping]="columnMapping"
              [uploading]="uploading"
              [uploaded]="uploaded"
              [csvPreview]="csvPreview"
              (mappingChange)="handleMappingChange($event)"
            ></app-upload-buyers-file-map>

            <app-upload-buyers-preview
              [csvPreview]="csvPreview"
              [columnMapping]="columnMapping"
              [isMappingComplete]="isMappingComplete"
            ></app-upload-buyers-preview>
          </ng-container>
        </ng-container>

        <app-upload-buyers-import
          *ngIf="csvPreview"
          [uploading]="uploading"
          [uploaded]="uploaded"
          [file]="file"
          [name]="name"
          [hasValidName]="hasValidName"
          [hasHeader]="hasHeader"
          [columnMapping]="columnMapping"
          (clearFileSelected)="clearSelectedFile()"
          [isMappingComplete]="isMappingComplete"
          (setUploading)="uploading = $event"
          (setUploaded)="uploaded = $event"
        ></app-upload-buyers-import>
      </ng-container>
    </ng-container>
  </ng-container>
</app-profile-layout>
